/* Page Panier — échantillons (15/09/2026).
   - 10 échantillons maximum par commande : au-delà, les derniers ajoutés sont retirés, avec un message.
   - Lien « Supprimer » sous le groupe d'échantillons pour tous les retirer d'un coup.
     Les croix sur chaque carte retirent toujours un seul échantillon. */
(function () {
  var MAX = 10;
  var NOTICE_KEY = 'hg_ech_limite';

  // Quantités à corriger pour ne garder que les MAX premiers échantillons ajoutés.
  // cart.js liste les derniers ajoutés en premier : on parcourt la liste à l'envers.
  function overLimit(cart) {
    var kept = 0;
    var updates = {};
    var changed = false;
    (cart.items || []).slice().reverse().forEach(function (item) {
      if (item.product_type !== 'Échantillon') return;
      var keep = Math.max(0, Math.min(item.quantity, MAX - kept));
      kept += keep;
      if (keep !== item.quantity) {
        updates[item.key] = keep;
        changed = true;
      }
    });
    return changed ? updates : null;
  }

  function takeNoticeFlag() {
    try {
      var flag = sessionStorage.getItem(NOTICE_KEY);
      sessionStorage.removeItem(NOTICE_KEY);
      return !!flag;
    } catch (e) {
      return false;
    }
  }

  function addRemoveAll(group, info) {
    var keys = [].map.call(group.querySelectorAll('.hg-cart-item__remove--mini[data-key]'), function (b) {
      return b.getAttribute('data-key');
    });
    if (!keys.length || group.querySelector('.hg-cart-item__remove--all')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hg-cart-item__remove hg-cart-item__remove--all';
    btn.textContent = 'Supprimer';
    btn.setAttribute('aria-label', 'Supprimer tous les échantillons');
    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.textContent = 'Suppression…';
      var updates = {};
      keys.forEach(function (k) { updates[k] = 0; });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function () { window.location.reload(); })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Supprimer';
        });
    });
    info.appendChild(btn);
  }

  function init() {
    var group = document.querySelector('.hg-cart-item--samples');
    var info = group && group.querySelector('.hg-cart-item__info');
    if (!group || !info) return;
    addRemoveAll(group, info);

    if (takeNoticeFlag()) {
      var note = document.createElement('p');
      note.setAttribute('role', 'status');
      note.style.cssText = 'margin:8px 0 0;font-size:12.5px;font-weight:600;line-height:1.4;color:#c0392b;background:#fdf2f1;border-radius:8px;padding:8px 10px;';
      note.textContent = MAX + ' échantillons maximum par commande : les échantillons en trop ont été retirés.';
      info.appendChild(note);
      return;
    }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = overLimit(cart);
        if (!updates) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) {
          if (!r.ok) return;
          try { sessionStorage.setItem(NOTICE_KEY, '1'); } catch (e) {}
          window.location.reload();
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
